/**
 * External dependencies
 */
import {
  SET_GLOBAL_INITIALIZE,
  SET_GLOBAL_LOADING,
  SET_GLOBAL_SIDE_BAR,
  SET_GLOBAL_SIDE_BAR_STATIC,
  SET_GLOBAL_THEME,
  SET_GLOBAL_HISTORIES
} from '@naruto/naruto-reducers/src/reducers/global/actions';

/**
 * Internal dependencies
 */
import { Dispatch, ThunkAction, Models, MiddleWare } from './types';

/* Global Action */
export const postGlobalReset =
  (): ThunkAction<Promise<void>, Models, MiddleWare, { type: string }> =>
  async (dispatch: Dispatch): Promise<void> => {
    dispatch(SET_GLOBAL_INITIALIZE());
  };
export const postGlobalLoading =
  (loading: boolean): ThunkAction<Promise<void>, Models, MiddleWare, { type: string }> =>
  async (dispatch: Dispatch): Promise<void> => {
    dispatch(
      SET_GLOBAL_LOADING({
        loading
      })
    );
  };
export const postGlobalSideBar =
  (open: boolean): ThunkAction<Promise<void>, Models, MiddleWare, { type: string }> =>
  async (dispatch: Dispatch): Promise<void> => {
    dispatch(
      SET_GLOBAL_SIDE_BAR({
        open
      })
    );
  };
export const postGlobalSideBarStatic =
  (open: boolean): ThunkAction<Promise<void>, Models, MiddleWare, { type: string }> =>
  async (dispatch: Dispatch): Promise<void> => {
    dispatch(
      SET_GLOBAL_SIDE_BAR_STATIC({
        open
      })
    );
  };
export const postGlobalTheme =
  (theme: string): ThunkAction<Promise<void>, Models, MiddleWare, { type: string }> =>
  async (dispatch: Dispatch): Promise<void> => {
    dispatch(
      SET_GLOBAL_THEME({
        theme
      })
    );
  };
export const postGlobalHistories =
  (histories: string[]): ThunkAction<Promise<void>, Models, MiddleWare, { type: string }> =>
  async (dispatch: Dispatch): Promise<void> => {
    dispatch(
      SET_GLOBAL_HISTORIES({
        histories
      })
    );
  };
